import React, { createContext, useState, useEffect } from "react";
import {
  createWeb3Modal,
  defaultConfig,
  useDisconnect,
  useSwitchNetwork,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers5/react";
import { useWeb3Modal } from "@web3modal/ethers5/react";
import { ethers } from "ethers";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import copy from "copy-to-clipboard";

export const appContext = createContext();
const projectId = "c9fb67051cfd714f16c3d23e9df4d518";
// const BSCTestnet = {
//   chainId: 80002,
//   name: "AMOYMATIC",
//   currency: "Matic",
//   explorerUrl: "https://amoy.polygonscan.com/",
//   rpcUrl: "https://rpc-amoy.polygon.technology/",
// };
const mainnet = [{
  chainId: 80002,
  name: "Amoy Testnet",
  currency: "MATIC",
  explorerUrl: "https://www.oklink.com/amoy",
  rpcUrl: "https://rpc-amoy.polygon.technology",
}, {
  chainId: 97,
  name: "BSC Testnet",
  currency: "BNB",
  explorerUrl: "https://testnet.bscscan.com/",
  rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545/",
}];
const Holesky = {
  chainId: 17000,
  name: "Holesky",
  currency: "ETH",
  explorerUrl: "https://holesky.etherscan.io/",
  rpcUrl: "https://rpc.holesky.ethpandaops.io",
};
const metadata = {
  name: "Aarma",
  description: "Aarma Dashboard",
  url: "https://mywebsite.com",
  icons: ["https://avatars.mywebsite.com/"],
};

const ethersConfig = defaultConfig({
  metadata,

  enableEIP6963: true,
  enableInjected: true,
  enableCoinbase: true,
  rpcUrl: "...",
});
createWeb3Modal({
  ethersConfig,
  chains: mainnet,
  projectId,
  defaultChainId: 97,
  enableAnalytics: true,
});



export default function MyContext({ children }) {
  const { open } = useWeb3Modal();
  const { walletProvider } = useWeb3ModalProvider();

  const [connectedAddress, setconnectedAddress] = useState();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { disconnect } = useDisconnect();
  const [balance, setBalance] = useState(0);
  const [USDTbalance, setUSDTBalance] = useState(0);
  const [settings, setsettings] = useState([]);
  const [rate, setrate] = useState(540);
  const [esigner, setesigner] = useState(null);
  const [tokenrate, settokenrate] = useState(0);
  const [contdata, setcontdata] = useState(null);
  const [smuser, setsmuser] = useState(null);
  const [account, setaccount] = useState(address);
  const [stakcontract, setstakcontract] = useState(null);
  const { switchNetwork } = useSwitchNetwork()

  const connectWallet = () => {
    try {
      open();
    } catch (err) {
      console.log("error : ", err);
    }
  };
  const toastError = (data) => {
    toast.error(data);
  };
  const toastSuccess = (data) => {
    toast.success(data);
  };
  const toastInfo = (data) => {
    toast(data, {
      // Custom Icon
      icon: "❕",
      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  };
  const formatAddress = (address) => {
    if (address) {
      return address.substr(0, 6) + "..." + address.substr(-6, 6);
    }
  };

  const copyaddress = (address) => {
    copy(address);
    toastSuccess("Copied");
  };
  const getSetting = async () => {
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "setting",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        // var dedata = decryptData(res.data);
        // console.log("dasas", res.data);
        if (res.data.error) {
          return "";
        }
        setsettings(res.data.data);
      });
  };

  useEffect(() => {
    setaccount(address)
  }, [address]);
  const getSigner = async () => {
    if (!isConnected) return;

    const ethersProvider = new ethers.providers.Web3Provider(walletProvider);
    const signer = await ethersProvider.getSigner();
    setesigner(signer)
  }
  const getsmcs = async () => {
    if (!isConnected || !account || !settings.token || esigner === null) return;
    let armacontract = new ethers.Contract(
      settings.token,
      JSON.parse(settings.token_abi),
      esigner
    );
    let usdtcontract = new ethers.Contract(
      settings.usdt,
      JSON.parse(settings.usdt_abi),
      esigner
    );
    let maincontract = new ethers.Contract(
      settings.contract,
      JSON.parse(settings.contract_abi),
      esigner
    );
    setstakcontract(maincontract);
    var balance = await armacontract.balanceOf(account);
    var usdtbalance = await usdtcontract.balanceOf(account);
    // console.log("getrate", balance);
    var getCurrentPhase = await maincontract.getCurrentPhase();
    var getCurrentPrice = await maincontract.getCurrentPrice();
    var phaseTokenAmounts = await maincontract.phaseTokenAmounts(getCurrentPhase);
    var tokensSoldInPhase = await maincontract.tokensSoldInPhase(getCurrentPhase);
    var tPhT = Number(ethers.utils.formatUnits(phaseTokenAmounts, 18))
    var tTsold = Number(ethers.utils.formatUnits(tokensSoldInPhase, 18))
    var contdatas = {
      current_phase: Number(getCurrentPhase),
      current_price: Number(getCurrentPrice) / 100,
      phase_token: tPhT,
      token_sold: tTsold,
      sold_per: tTsold * 100 / tPhT
    };
    setcontdata(contdatas);
    setBalance(Number(ethers.utils.formatUnits(balance, 18)).toFixed(2));
    setUSDTBalance(Number(ethers.utils.formatUnits(usdtbalance, 18)).toFixed(2));
  };
  useEffect(() => {
    if (address) {
      setconnectedAddress(address);
    } else {
      setconnectedAddress("");
    }
  }, [address]);

  useEffect(() => {
    getsmcs();
    // }, [account, address,library, settings]);
  }, [isConnected, address, account, walletProvider, settings, esigner]);
  useEffect(() => {
    getSigner();
  }, [isConnected, walletProvider]);
  useEffect(() => {
    getSetting()
  }, []);

  return (
    <>
      <Toaster
        position="top-left"
        toastOptions={{
          // Define default options
          className: "",
          duration: 3000,
          style: {
            background: "#ffa518",
            color: "#fff",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }} />
      <appContext.Provider
        value={{
          settings: settings,
          library: ethers,
          balance,
          esigner,
          address,
          tokenrate,
          smuser,
          // account: ovrAddress ? ovrAddress : address ? address.toLowerCase() : address,
          account: account ? account.toLowerCase() : account,
          setaccount,
          formatAddress,
          toastError,
          toastSuccess,
          toastInfo,
          getsmcs, USDTbalance,
          ethers,
          rate,
          copyaddress, connectWallet,
          contdata, disconnect,
          stakcontract,
          switchNetwork,
        }}
      >
        {children}
      </appContext.Provider></>
  );
}
